import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { ProvinceService } from '../../../shared/services/lookups/province.service';
import { Province } from '../../../shared/classes/lookups/province.model';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-province',
  templateUrl: './province.component.html',
  styleUrls: ['./province.component.css']
})
export class ProvinceComponent implements OnInit {

  provinces: {} = [];
  constructor(public restApi: ApiService) { }

  @Output()
  selectedProvinceID: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit() {
    this.loadProvince();
  }

  // Get employees list
  loadProvince() {
    return this.restApi.getProvince().subscribe((data: {}) => {
      this.provinces = data;
    });
  }

  onChange(message) {
    this.selectedProvinceID.emit(message);
  }
}
